<div class="course-details-modal">
  <div class="course-details-modal-header">
    <h2 mat-dialog-title>{{ course?.name }}</h2>
    <button mat-icon-button class="close-button" (click)="close()" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <div class="course-meta">
      <div class="meta-chip">
        <mat-icon class="meta-icon">schedule</mat-icon>
        <span>{{ course?.duration_days }} day{{ course?.duration_days !== 1 ? 's' : '' }}</span>
      </div>
      <div class="meta-chip" *ngIf="!loading">
        <mat-icon class="meta-icon">list_alt</mat-icon>
        <span>{{ activities.length }} activit{{ activities.length !== 1 ? 'ies' : 'y' }}</span>
      </div>
    </div>

    <div *ngIf="loading" class="loading-container">
      <mat-spinner diameter="32"></mat-spinner>
      <p>Loading activities...</p>
    </div>

    <div *ngIf="error && !loading" class="error-message">
      <mat-icon>error_outline</mat-icon>
      <p>Could not load course activities.</p>
    </div>

    <div *ngIf="!loading && !error && activities.length === 0" class="empty-message">
      <p>No activities defined for this course yet.</p>
    </div>

    <div *ngIf="!loading && !error && activities.length > 0" class="activities-timeline">
      <div *ngFor="let activity of activities; let i = index; let last = last" class="activity-item">
        <div class="timeline-track">
          <div class="step-number">{{ i + 1 }}</div>
          <div class="timeline-line" *ngIf="!last"></div>
        </div>
        <div class="activity-content">
          <h4 class="activity-title">{{ activity.title }}</h4>
          <p *ngIf="activity.description" class="activity-description" [innerHTML]="activity.description"></p>
          <div *ngIf="getPrereqNames(activity).length > 0" class="prereq-row">
            <mat-icon class="prereq-icon">lock</mat-icon>
            <span class="prereq-text">Requires: {{ getPrereqNames(activity).join(', ') }}</span>
          </div>
        </div>
      </div>
    </div>
  </mat-dialog-content>
</div>
